module.exports = __webpack_public_path__ + "img/pencil.6dbb8919.svg";